import { InsightProvider, MessagingProvider, TelephonyProvider, VoiceProvider } from '../telephony.provider';
import { Injectable } from '@angular/core';
import { FunctionLifeCycle } from '../telephonyutils';
import { IbexVoiceProvider } from './ibex.voice.provider';
import { IbexMessagingProvider } from './ibex.messaging.provider';
import { IbexInsightProvider } from './ibex.insight.provider';

@Injectable({ providedIn: 'root' })
export class IbexTelephonyProvider extends TelephonyProvider {
  constructor(private _messaging: IbexMessagingProvider,
    private _voice: IbexVoiceProvider,
    private _insight: IbexInsightProvider) {
    super();
  }
  override name(): string {
    return 'ibex';
  }
  override get messaging(): MessagingProvider {
    return this._messaging;
  }

  override get voice(): VoiceProvider {
    return this._voice;
  }

  override get insight(): InsightProvider {
    return this._insight;
  }
  override init(lf: FunctionLifeCycle): void {
    lf?.onStart();

    console.log(new Date().toLocaleString() + '  ➤  ibex init');

    lf?.onEnd();
  }
}
